import React from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { BsFillCheckCircleFill, BsFillExclamationDiamondFill, BsCircleFill } from 'react-icons/bs';
import { TbConfetti } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

/**
 * DoneComponent
 * 
 * shows customer message that forms fill are done
 * 
 * @returns None
 */
const DoneComponent = (props) => {

    const navigate = useNavigate();

    return (
        <div className="mt-5 mb-5">
            {props.isLoading ?
                <div className="text-center">
                    <p>Ihre Daten werden verarbeitet.</p>
                    <Spinner animation="grow" className="btn-energo" />&nbsp;
                    <Spinner animation="grow" className="btn-energo" />&nbsp;
                    <Spinner animation="grow" className="btn-energo" />
                </div>
                : null}
            {props.registrationDone ?
                <div className="text-center">
                    <Row className="mb-5">
                        <div className="animate__animated animate__backInRight">
                            <TbConfetti size={80} className="text-energo animate__animated animate__tada animate__delay-2s" />
                        </div>
                        <h5 className="text-energo">Fertig</h5>
                    </Row>
                    <Row>
                        <Col xs="12">
                            <p>Vielen Dank für Ihre Registrierung. Sie können das ENERGO Managementportal ab jetzt nutzen.</p>
                            <Button className="btn-energo" onClick={() => navigate("/dashboard")}>Zum Portal</Button>
                        </Col>
                    </Row>
                </div>
                : null}
            {props.saveError === "exists" ?
                <div>
                    <h1 className="text-warning"><BsCircleFill /></h1>
                    <p>Die eingegebene E-Mail Adresse existiert bereit bei uns. Melden Sie sich bei Support</p>
                </div>
                : null}
            {props.saveError === "server" ?
                <div>
                    <h1 className="text-danger"><BsFillExclamationDiamondFill /></h1>
                    <p>Server Error! Versuchen Sie später noch einen mal</p>
                </div>
                : null}
        </div>
    )
}

export default DoneComponent;